export default "__VITE_ASSET__Cyu10XmV__"